"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIframe = exports.IframeStatus = exports.GSUNavigation = void 0;
const error_html_1 = require("./error.html");
// We use a version file, and not the package.json because using the package.json changes the root of the dist package.
// We need everything inside src, plus we don't need the whole package.json in the build output. Smaller is better.
const version_json_1 = require("./version.json");
const targetPageUrls = {
    learn: 'https://embed.getsetup.io/embedded/{embeddingOrgId}/learn',
    fitness: 'https://embed.getsetup.io/embedded/{embeddingOrgId}/fitness',
    joinClass: 'https://lobby-embed.getsetup.io/session/{sessionId}',
    // The below will be updated to final URLs later.
    article: 'https://embed-webapp.www.getsetup.io/article/{partnerId}/{articleId}',
    discover: 'https://embed-webapp.www.getsetup.io/discovery/{partnerId}',
    series: 'https://embed-webapp.www.getsetup.io/series/{partnerId}/{seriesId}',
    watch: 'https://embed-webapp.www.getsetup.io/watch/{partnerId}/{classId}',
    watchLive: 'https://embed-webapp.www.getsetup.io/watch/{partnerId}/live/{sessionId}',
};
const navigationActions = Object.assign(Object.assign({}, targetPageUrls), { 
    // No one should ever see these messages, we only care about the keys in this object. But just in case...
    login: 'Error, the hosting page should handle login navigation actions.', home: 'Error, the hosting page should handle homepage navigation actions.', help: 'Error, the hosting page should handle help navigation actions.' });
exports.GSUNavigation = 'gsuNavigation';
var IframeStatus;
(function (IframeStatus) {
    IframeStatus["LOADING"] = "LOADING";
    IframeStatus["SUCCESS"] = "SUCCESS";
    IframeStatus["ERROR"] = "ERROR";
})(IframeStatus = exports.IframeStatus || (exports.IframeStatus = {}));
/**
 * Creates an iframe to embed GetSetUp content in the host page.
 * @param CreateIframeOptions - An options object containing fields as described in the CreateIframeOptions interface.
 * @returns An `IframeInstance` object with a `cleanUp()` function that can be used to clean up timers and event listeners before recreating the iframe.
 */
function createIframe({ targetElementId, targetPage, sessionId, classId, articleId, seriesId, embeddingOrgId, partnerId, deviceId, disableChat, disableHelp, navigationCallBack, tokenRequestCallBack, statusCallBack, linkTemplates, targetUrls, loadingTimeoutInMs, themeOptions, analyticsInfo, pageId, }) {
    if (targetPage == 'joinClass' && !sessionId) {
        throw new Error('sessionId is required if you are loading a join class page.');
    }
    if ((targetPage == 'joinClass' || targetPage == 'learn' || targetPage == 'fitness') && !navigationCallBack) {
        throw new Error('navigationCallBack is required if you are loading a join class, learn, or fitness page.');
    }
    if (!Object.keys(targetPageUrls).includes(targetPage)) {
        throw new Error('The targetPage should be one of "learn" | "fitness" | "joinClass" | "discover" | "watch" | "watchLive".');
    }
    if (targetPage == 'watch' && !classId) {
        throw new Error('classId is required if you are loading a watch page.');
    }
    if (targetPage == 'watchLive' && !sessionId) {
        throw new Error('sessionId is required if you are loading a watchLive page.');
    }
    if (targetPage == 'article' && !articleId) {
        throw new Error('articleId is required if you are loading a article page.');
    }
    if (targetPage == 'series' && !seriesId) {
        throw new Error('seriesId is required if you are loading a series page.');
    }
    let normalisedOrgId = '';
    if (partnerId) {
        // We don't want to transform the partner code. It is case sensitive.
        normalisedOrgId = partnerId;
    }
    else if (embeddingOrgId) {
        normalisedOrgId = embeddingOrgId.toLowerCase();
    }
    else {
        throw new Error('Either embeddingOrgId or partnerId is required.');
    }
    const targetPages = Object.assign(Object.assign({}, targetPageUrls), targetUrls);
    targetPages.learn = targetPages.learn.replace('{embeddingOrgId}', normalisedOrgId);
    targetPages.fitness = targetPages.fitness.replace('{embeddingOrgId}', normalisedOrgId);
    targetPages.joinClass = targetPages.joinClass.replace('{embeddingOrgId}', normalisedOrgId);
    targetPages.watch = targetPages.watch
        .replace('{embeddingOrgId}', normalisedOrgId)
        .replace('{partnerId}', normalisedOrgId);
    targetPages.watchLive = targetPages.watchLive
        .replace('{embeddingOrgId}', normalisedOrgId)
        .replace('{partnerId}', normalisedOrgId);
    targetPages.discover = targetPages.discover
        .replace('{embeddingOrgId}', normalisedOrgId)
        .replace('{partnerId}', normalisedOrgId);
    targetPages.article = targetPages.article
        .replace('{embeddingOrgId}', normalisedOrgId)
        .replace('{partnerId}', normalisedOrgId);
    targetPages.series = targetPages.series
        .replace('{embeddingOrgId}', normalisedOrgId)
        .replace('{partnerId}', normalisedOrgId);
    if (sessionId) {
        targetPages.joinClass = targetPages.joinClass.replace('{sessionId}', sessionId);
        targetPages.watch = targetPages.watch.replace('{sessionId}', sessionId);
        targetPages.watchLive = targetPages.watchLive.replace('{sessionId}', sessionId);
    }
    if (classId) {
        targetPages.joinClass = targetPages.joinClass.replace('{classId}', classId);
        targetPages.watch = targetPages.watch.replace('{classId}', classId);
    }
    if (articleId) {
        targetPages.article = targetPages.article.replace('{articleId}', articleId);
    }
    if (seriesId) {
        targetPages.series = targetPages.series.replace('{seriesId}', seriesId);
    }
    const targetElement = document.getElementById(targetElementId);
    if (!targetElement)
        throw new Error(`GSU Embedded Shell cannot find the targetElement ${targetElementId} to mount the iframe.`);
    const gsuEmbeddedIframe = document.createElement('iframe');
    const iframeSrc = new URL(targetPages[targetPage]);
    iframeSrc.searchParams.append('embedding-org-id', normalisedOrgId);
    // This device-id method is deprecated, it should be removed in a future version.
    if (deviceId)
        iframeSrc.searchParams.append('device-id', deviceId);
    if (disableChat)
        iframeSrc.searchParams.append('disable-chat', 'true');
    if (disableHelp)
        iframeSrc.searchParams.append('disable-help', 'true');
    if (themeOptions) {
        const themeOptionsEncoded = encodeURIComponent(btoa(JSON.stringify(themeOptions)));
        iframeSrc.searchParams.append('theme-options', themeOptionsEncoded);
    }
    if (analyticsInfo) {
        const analyticsInfoEncoded = encodeURIComponent(btoa(JSON.stringify(analyticsInfo)));
        iframeSrc.searchParams.append('analytics-info', analyticsInfoEncoded);
        // This will override the previous device-id above, but that's what we want.
        // The other device-id method is deprecated, both of these should be removed in a future version.
        if (analyticsInfo.deviceId)
            iframeSrc.searchParams.set('device-id', analyticsInfo.deviceId);
    }
    // Pass the join class link template to allow the page to construct hosting site links for SEO.
    if (linkTemplates === null || linkTemplates === void 0 ? void 0 : linkTemplates.joinClass)
        iframeSrc.searchParams.append('link-template-join-class', linkTemplates === null || linkTemplates === void 0 ? void 0 : linkTemplates.joinClass);
    // Pass the navigation path link template to allow the page to construct hosting site links for SEO.
    if (linkTemplates === null || linkTemplates === void 0 ? void 0 : linkTemplates.learnPage)
        iframeSrc.searchParams.append('link-template-navigation-path', linkTemplates === null || linkTemplates === void 0 ? void 0 : linkTemplates.learnPage);
    // Pass the navigation path link template to allow the page to construct hosting site links for SEO.
    if (linkTemplates === null || linkTemplates === void 0 ? void 0 : linkTemplates.fitnessPage)
        iframeSrc.searchParams.append('link-template-navigation-path', linkTemplates === null || linkTemplates === void 0 ? void 0 : linkTemplates.fitnessPage);
    // Pass the navigation path link template to allow the page to construct hosting site links for SEO.
    if (linkTemplates === null || linkTemplates === void 0 ? void 0 : linkTemplates.discoverPage)
        iframeSrc.searchParams.append('link-template-navigation-path', linkTemplates === null || linkTemplates === void 0 ? void 0 : linkTemplates.discoverPage);
    // Pass the navigation path link template to allow the page to construct hosting site links for SEO.
    if (linkTemplates === null || linkTemplates === void 0 ? void 0 : linkTemplates.watchPage)
        iframeSrc.searchParams.append('link-template-navigation-path', linkTemplates === null || linkTemplates === void 0 ? void 0 : linkTemplates.watchPage);
    if (linkTemplates === null || linkTemplates === void 0 ? void 0 : linkTemplates.watchLivePage)
        iframeSrc.searchParams.append('link-template-navigation-path', linkTemplates === null || linkTemplates === void 0 ? void 0 : linkTemplates.watchLivePage);
    if (pageId)
        iframeSrc.searchParams.append('page-id', pageId);
    // If there is no navigation callback then set the internal navigation flag on the iframe.
    // This will allow the iframe to navigate to the watch page without the parent page needing to handle the navigation.
    // This supports the simple version of the embed.
    if (!navigationCallBack)
        iframeSrc.searchParams.append('internal-nav', 'true');
    // Pass the list of permissions into the iframe.
    // This list has changed over time and partners can't update this package instantly.
    // So we want to be able to toggle features on/off based on what permissions we have.
    const sandboxPermissions = 'allow-scripts allow-same-origin allow-popups allow-downloads';
    iframeSrc.searchParams.append('sandbox-permissions', sandboxPermissions);
    const tellHostingPageIframeStatus = errorReporter({
        statusCallBack,
        iframeSrc,
        createIframeOptions: {
            targetElementId,
            targetPage,
            sessionId,
            embeddingOrgId,
            targetUrls,
            loadingTimeoutInMs,
        },
    });
    gsuEmbeddedIframe.setAttribute('src', iframeSrc.toString());
    let hasLoadedSuccessfully = false;
    const handleNotLoading = (message) => {
        if (!hasLoadedSuccessfully) {
            //Fire the status callback with an error message.
            tellHostingPageIframeStatus({
                status: IframeStatus.ERROR,
                message: message !== null && message !== void 0 ? message : 'The GetSetUp iframe did not load successfully.',
            });
            gsuEmbeddedIframe.setAttribute('srcdoc', error_html_1.errorHtml);
        }
        clearTimeout(loadingTimeout);
    };
    const loadingTimeoutThreshold = loadingTimeoutInMs !== null && loadingTimeoutInMs !== void 0 ? loadingTimeoutInMs : 60000;
    const handleTimeout = () => {
        return handleNotLoading('The GetSetUp iframe timed out.');
    };
    const loadingTimeout = setTimeout(handleTimeout, loadingTimeoutThreshold);
    // Try to load the head so we know if the page is working.
    if (targetPage === 'watch' || targetPage === 'discover' || targetPage === 'article' || targetPage === 'series') {
        // TODO: do we want to support this for the new webapp, or just try to load the page.
        // Maybe kill the backed in error page.
        hasLoadedSuccessfully = true;
    }
    else {
        fetch(iframeSrc, { method: 'HEAD', mode: 'cors' })
            .then((response) => {
            if (!response.ok)
                handleNotLoading('HEAD Response was not ok.');
        })
            .catch((error) => {
            var _a;
            const errorMessage = (_a = error.message) !== null && _a !== void 0 ? _a : error;
            handleNotLoading(`HEAD Response errored. ${errorMessage}`);
        });
    }
    // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#attr-sandbox for info about sandboxing iframes.
    // We need:
    // * allow-scripts - so our js runs.
    // * allow-same-origin - otherwise our postMessage messages do not have an origin attached, and we would like to check the origin of messages.
    // * allow-popups - to allow links with target _blank attribute to work.
    // * allow-downloads - so users can download the attachments that might be included with some class notes.
    gsuEmbeddedIframe.setAttribute('sandbox', sandboxPermissions);
    gsuEmbeddedIframe.setAttribute('allow', 'fullscreen; autoplay;');
    gsuEmbeddedIframe.setAttribute('allowfullscreen', ''); // To support Firefox and Safari.
    gsuEmbeddedIframe.setAttribute('scrolling', 'no');
    gsuEmbeddedIframe.style.width = '100%';
    gsuEmbeddedIframe.style.border = 'none';
    gsuEmbeddedIframe.style.height = '100%';
    if (targetElement.replaceChildren) {
        targetElement.replaceChildren(gsuEmbeddedIframe);
    }
    else {
        // Support older browsers.
        // https://caniuse.com/?search=replaceChildren
        targetElement.innerHTML = '';
        targetElement.appendChild(gsuEmbeddedIframe);
    }
    tellHostingPageIframeStatus({ status: IframeStatus.LOADING, message: 'The GetSetUp iframe is currently loading.' });
    const originsFromTargetUrls = Object.entries(targetPages).map(([_key, value]) => new URL(value).origin);
    // We have to add the parent page to the list because the origin of messages from srcdoc is the parent page, not the iframe.
    const currentHost = window.location.origin;
    const validMessageOrigins = [
        currentHost,
        // And any other origins that were passed in.
        ...originsFromTargetUrls,
    ];
    // We currently assume that there is one iframe on the page and only check for gsu* properties in the event.
    // If we have more iframes we will have to identify them somehow.
    const messageHandler = (event) => {
        var _a;
        // Only allow messages from our own iframes.
        if (validMessageOrigins.includes(event.origin)) {
            if (event.data.gsuIframeLoaded) {
                // We got a message from the JS running in the HTML head of the iframe content, so we know the page is downloading and executing.
                if (!hasLoadedSuccessfully) {
                    //We only want to fire this callback once when the page first loads.
                    tellHostingPageIframeStatus({
                        status: IframeStatus.SUCCESS,
                        message: 'The GetSetUp iframe loaded successfully.',
                    });
                }
                hasLoadedSuccessfully = true;
            }
            else if (event.data.gsuDocumentHeight) {
                // Responsive styling, but the joinClass page doesn't need it, that handles sizing a different way.
                if (targetPage !== 'joinClass' && targetPage !== 'watch')
                    gsuEmbeddedIframe.style.height = `${event.data.gsuDocumentHeight}px`;
                if (!hasLoadedSuccessfully) {
                    // We only want to fire this callback once when the page first loads.
                    // We are leaving this here for now, but a future version will remove this call and rely on the above gsuIframeLoading message.
                    tellHostingPageIframeStatus({
                        status: IframeStatus.SUCCESS,
                        message: 'The GetSetUp iframe loaded successfully.',
                    });
                }
                hasLoadedSuccessfully = true;
            }
            else if (event.data.gsuNavigation) {
                const pageToNavigateTo = event.data.gsuNavigation.targetPage; //TODO: change this to gsuNavigation.navigationAction?
                const sessionId = event.data.gsuNavigation.sessionId;
                const classSlug = event.data.gsuNavigation.classSlug;
                const classId = event.data.gsuNavigation.classId;
                const articleId = event.data.gsuNavigation.articleId;
                const seriesId = event.data.gsuNavigation.seriesId;
                // Make sure the page we are asking the hosting page to navigate to is a valid one of the targetPages we support.
                if (Object.keys(navigationActions).includes(pageToNavigateTo) && navigationCallBack) {
                    navigationCallBack({ navigationAction: pageToNavigateTo, articleId, classId, sessionId, classSlug, seriesId });
                }
            }
            else if (event.data.gsuAnchorNavigation) {
                // We got a request from the iframe to scroll to a location pointed to by an <a href="#sectionName">
                // But the iframe can't do that, so we scroll the parent window on it's behalf.
                const y = event.data.gsuAnchorNavigation;
                window.scrollTo({ left: 0, top: y, behavior: 'smooth' });
            }
            else if (event.data.gsuTokenRequest) {
                // The page is asking for a token, call the token callback to get a token.
                // But the caller might have disabled chat, and not given us a tokenRequestCallBack.
                if (tokenRequestCallBack) {
                    // If we wrap the callback in a Promise.resolve then we can treat the result as a promise even if we just got passed a plain string.
                    (_a = Promise.resolve(tokenRequestCallBack())) === null || _a === void 0 ? void 0 : _a.then((token) => {
                        var _a;
                        if (token) {
                            // Got a token, send it to the iframe.
                            const messageToIframe = { gsuTokenFromHost: token };
                            (_a = gsuEmbeddedIframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(messageToIframe, iframeSrc.origin);
                        }
                    }).catch((error) => {
                        console.error(error);
                    });
                }
            }
        }
    };
    window.addEventListener('message', messageHandler);
    return {
        cleanUp: () => {
            clearTimeout(loadingTimeout);
            window.removeEventListener('message', messageHandler);
        },
    };
}
exports.createIframe = createIframe;
function errorReporter({ statusCallBack, iframeSrc, createIframeOptions, }) {
    const onError = (iframeStatusMessage) => {
        if (statusCallBack)
            statusCallBack(iframeStatusMessage);
        if (iframeStatusMessage.status === IframeStatus.ERROR) {
            sendToSentry({
                iframeSrc,
                message: iframeStatusMessage.message,
                createIframeOptions,
            });
            // TODO: Send a sample of successful loads mostly so we can keep an eye on the timing.
            // TODO: Allow us to remotely control the sample rate? Extract a sample rate from the HEAD request?
            // } else if (iframeStatusMessage.status === IframeStatus.SUCCESS && Math.random() > 0.01) {
            //   SendTransactionToSentryWithTimingData(blah)
            // }
        }
    };
    return onError;
}
function sendToSentry({ message, level = 'error', iframeSrc, createIframeOptions }) {
    const errorData = JSON.stringify({
        timestamp: Math.floor(Date.now() / 1000),
        level,
        platform: 'javascript',
        release: version_json_1.version,
        environment: (iframeSrc === null || iframeSrc === void 0 ? void 0 : iframeSrc.host) === 'embed.getsetup.io' || (iframeSrc === null || iframeSrc === void 0 ? void 0 : iframeSrc.host) === 'lobby-embed.getsetup.io'
            ? 'production'
            : 'development',
        message: {
            formatted: message,
        },
        tags: {
            embeddingOrgId: createIframeOptions.embeddingOrgId,
            targetPage: createIframeOptions.targetPage,
        },
        request: {
            method: 'GET',
            url: window.location.href,
        },
        contexts: {
            browser: {
                name: navigator.userAgent,
            },
            state: {
                state: {
                    type: 'gsu-embedded-state',
                    value: {
                        createIframeOptions,
                        timeSincePageLoadInMs: (performance === null || performance === void 0 ? void 0 : performance.now) ? performance.now() : undefined,
                    },
                },
            },
        },
    });
    // Call sentry
    const sentryHost = 'https://o458054.ingest.sentry.io';
    const sentryPublicKey = '843a7e87622d4650a247cac3bb034190';
    const sentryClient = 'gsu-embedded';
    if (navigator === null || navigator === void 0 ? void 0 : navigator.sendBeacon) {
        navigator.sendBeacon(`${sentryHost}/api/4504795180892160/store/?sentry_version=7&sentry_key=${sentryPublicKey}&sentry_client=${sentryClient}`, errorData);
    }
    else if (fetch) {
        fetch(`${sentryHost}/api/4504795180892160/store/?sentry_version=7&sentry_key=${sentryPublicKey}&sentry_client=${sentryClient}`, { method: 'POST', body: errorData });
    }
    // sendBeacon didn't work, fetch didn't work, this browser is probably IE11 from 2013, we are not going to report this error.
}
//# sourceMappingURL=index.js.map